export const package_mixins = {
  methods: {
    m__has_package(channel) {
      const package_found = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === channel)
      if (package_found) {
        return this.dayjs().isBefore(this.dayjs(new Date(package_found.license_to)), 's')
      }
      return false
    },

    m__check_marketing_package(feature) {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing[feature] === true
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/package.js